module.exports = __webpack_public_path__ + "assets/media/1.88d61fb0.wav";